module.exports = __webpack_public_path__ + "static/img/iPadMini2.8e5c86f2.png";